import React, { useEffect } from 'react'
import { useReduxDispatch, useReduxSelector } from '../redux/hooks';
import { ChatApi } from '../redux/api/ChatApi';
import { ChatVisibility } from '../types/ChatVisibility';
import { ChatIsUnRead } from '../util/ChatUtils';

export default function ChatCount(props: { showLabel?: boolean, showZero?: boolean }) {
    const dispatch = useReduxDispatch();
    const { data: visibility } = ChatApi.useGetMyVisibilityQuery();
    const { notifications } = useReduxSelector(s => s.chat);
    const { data: chats } = ChatApi.useGetChatsQuery();
    const { requests, config } = useReduxSelector(s => s.chat);
    const { data: userProfile } = ChatApi.useGetProfileQuery();

    //console.log('ChatCount', chats?.length, requests?.length);
    //The unread count is any chat who's last read date is less than the last message date
    const unreadChats = chats?.concat(requests).filter(c => ChatIsUnRead(userProfile?.Uid, c));

    useEffect(() => {
        if (!userProfile) return;

        if (config && unreadChats?.length && visibility?.Visibility !== ChatVisibility.Offline && notifications !== null) {
            document.title = `(${unreadChats?.length}) ${userProfile?.Site_Title}`;
        } else {
            document.title = `${userProfile?.Site_Title}`;
        }
    }, [chats, requests, userProfile, config])


    if (props.showLabel == false || visibility?.Visibility == ChatVisibility.Offline)
        return <></>

    if (unreadChats?.length || props.showZero)
        return (
            <>{unreadChats?.length || 0}</>
        )
}
